/**
 * Border radius scale — informs MUI `shape.borderRadius` (default = 12)
 * and component overrides (Chip uses 999, Card uses 16, etc.).
 */
export const radii = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  full: 999,
} as const;

export type RadiusKey = keyof typeof radii;
